// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DrawOffer_wrapper__2r503"};